module.exports = __webpack_public_path__ + "img/073628e.77212b42.png";